var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.371094C4.48 0.371094 0 4.90962 0 10.5017C0 16.0938 4.48 20.6324 10 20.6324C15.52 20.6324 20 16.0938 20 10.5017C20 4.90962 15.52 0.371094 10 0.371094ZM11 15.567H9V9.48866H11V15.567ZM11 7.46254H9V5.43641H11V7.46254Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTooltip);
export default __webpack_public_path__ + "static/media/info-tooltip.b11ab304ce970d05f04349a86e6cde7c.svg";
export { ForwardRef as ReactComponent };